import React from 'react';
import { useHistory } from 'react-router';

type Props = {
  route: string;
};

export const CamposDinamicosNotFound = ({ route }: Props) => {
  const history = useHistory();

  return (
    <div className="not-found" style={{ maxWidth: '500px' }}>
      <h1>
        <em className="far fa-frown" />
      </h1>
      <h2>
        Não existem campos dinâmicos cadastrados para essa
        entidade/funcionalidade.
      </h2>
      <button
        data-test-id="btn-notFound"
        className="btn module-color icon-left inline center mt-xs"
        type="button"
        onClick={() => history.push(route)}
      >
        <em className="fa fa-arrow-left" /> Voltar
      </button>
    </div>
  );
};
